export default "__VITE_ASSET__Cc67fgbs__"